import { render, staticRenderFns } from "./VerificationData.vue?vue&type=template&id=0e82006d&scoped=true&lang=pug&"
import script from "./VerificationData.vue?vue&type=script&lang=js&"
export * from "./VerificationData.vue?vue&type=script&lang=js&"
import style0 from "./VerificationData.vue?vue&type=style&index=0&id=0e82006d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82006d",
  null
  
)

export default component.exports